<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="min-width: 500px">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Add Main Switch Board (MSB)</div>
        <q-space />
        <q-btn v-close-popup icon="close" flat round dense />
      </q-card-section>

      <q-form @submit="onSubmit" @reset="onReset">
        <q-card-section>
          <q-input
            :model-value="formData.name"
            label="Name *"
            filled
            :rules="[val => !!val || 'Name is required']"
            class="q-mb-md"
            @update:model-value="emit('update:name', $event)"
          />

          <q-input
            :model-value="formData.description"
            label="Description"
            filled
            type="textarea"
            rows="2"
            class="q-mb-md"
            @update:model-value="emit('update:description', $event)"
          />

          <div class="row q-col-gutter-md">
            <div class="col-6">
              <q-input
                :model-value="formData.voltage_rating"
                label="Voltage Rating"
                filled
                hint="e.g., 415V"
                @update:model-value="emit('update:voltage-rating', $event)"
              />
            </div>
            <div class="col-6">
              <q-input
                :model-value="formData.current_rating"
                label="Current Rating"
                filled
                hint="e.g., 2000A"
                @update:model-value="emit('update:current-rating', $event)"
              />
            </div>
          </div>

          <div class="row q-col-gutter-md q-mt-sm">
            <div class="col-6">
              <q-input
                :model-value="formData.manufacturer"
                label="Manufacturer"
                filled
                @update:model-value="emit('update:manufacturer', $event)"
              />
            </div>
            <div class="col-6">
              <q-input
                :model-value="formData.model"
                label="Model"
                filled
                @update:model-value="emit('update:model', $event)"
              />
            </div>
          </div>

          <q-select
            :model-value="formData.location"
            label="Location"
            filled
            :options="locationOptions"
            emit-value
            map-options
            class="q-mt-md"
            @update:model-value="emit('update:location', $event)"
          />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn v-close-popup flat label="Cancel" color="grey" />
          <q-btn flat label="Reset" type="reset" color="warning" />
          <q-btn unelevated label="Save" type="submit" color="red" :loading="saving" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    locationOptions: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:description',
    'update:voltage-rating',
    'update:current-rating',
    'update:manufacturer',
    'update:model',
    'update:location',
    'submit',
    'reset',
  ]);

  function onSubmit() {
    emit('submit');
  }

  function onReset() {
    emit('reset');
  }
</script>
